import { useEffect, useState } from "react"
import { Select, MenuItem, FormControl, InputLabel, Backdrop, CircularProgress, Box, Divider, Grid, Paper, Table, TableCell, TableHead, TableRow, TextField, Typography, TableBody, TableFooter, useMediaQuery, useTheme, Card, CardContent, Chip } from "@mui/material"
import axios from "../api/axios"
import useAuth from '../hooks/useAuth';
import ExportButtons from './ExportButtons';

export default function RetirosView(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const getDesde = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;

        var yyyy = cual.getFullYear();
        if (mm < 10) {
            mm = '0' + mm;
        }
        var today = yyyy + '-' + mm + '-01';
        return today;
    }

    const getHasta = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();

        if (mm == 12) {
            mm = 1
            yyyy++;
        } else {
            mm++;
        }

        let prox = new Date(yyyy, (mm - 1), 1);
        prox.setDate(prox.getDate() - 1)

        mm = prox.getMonth() + 1;
        yyyy = prox.getFullYear();
        let dd = prox.getDate();

        if (mm < 10) {
            mm = '0' + mm;
        }
        if (dd < 10) {
            dd = '0' + dd;
        }

        var today = yyyy + '-' + mm + '-' + dd;
        return today;
    }
    const [tipo, setTipo] = useState(0);
    const [tipoRetiroGanancia, setTipoRetiroGanancia] = useState(0)
    const [desde, setDesde] = useState(getDesde());
    const [hasta, setHasta] = useState(getHasta());
    const [rows, setRows] = useState([])
    const [procesando, setProcesando] = useState(false)
    const [totalMovs, setTotalMovs] = useState(0.00)

    const { auth, setAuth } = useAuth();


    useEffect(() => {
        actRows();
    }, [desde, hasta, tipo, tipoRetiroGanancia])



    const actRows = async () => {
        setProcesando(true)
        let aRows = []
        let total = 0.00
        try {
            const respuesta = await axios.post("movimientos/retiros", {
                inversionista: auth.inversionista,
                desde: desde,
                hasta: hasta,
                tipo: tipo,
                tipoRetiroGanancia: tipoRetiroGanancia
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta == "S") {
                aRows = data.lista;
                data.lista.forEach((row) => {
                    total = total + parseFloat(row.monto)
                })
            }
        } catch (error) {
            console.log(error)
        }
        setRows(aRows)
        setTotalMovs(total)
        setProcesando(false)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={() => { setProcesando(false) }}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    // Renderizar tarjetas para vista móvil
    const renderMobileCards = () => {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pb: 2 }}>
                {rows.map((row) => {
                    const monto = parseFloat(row.monto);
                    const isPositive = monto >= 0;

                    return (
                        <Card
                            key={row.id}
                            sx={{
                                border: '1px solid rgba(30, 58, 95, 0.1)',
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(30, 58, 95, 0.08)'
                            }}
                        >
                            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography sx={{ fontWeight: 600, color: '#1e3a5f', fontSize: '0.85rem' }}>
                                            {row.nombre}
                                        </Typography>
                                        <Typography sx={{ color: '#718096', fontSize: '0.7rem', mt: 0.5 }}>
                                            {row.fecha}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ textAlign: 'right' }}>
                                        <Typography sx={{
                                            fontWeight: 700,
                                            fontSize: '1rem',
                                            color: isPositive ? '#d4af37' : '#dc2626'
                                        }}>
                                            {monto.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                        </Card>
                    );
                })}
            </Box>
        );
    };

    // Vista móvil
    if (isMobile) {
        return (
            <Box sx={{
                minHeight: "100vh",
                position: "relative",
                p: 1,
                display: 'flex',
                flexDirection: 'column'
            }}>
                {objWait()}

                {/* Header */}
                <Paper sx={{
                    p: 2,
                    mb: 1.5,
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderRadius: 2
                }}>
                    <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 700, textAlign: 'center' }}>
                        Consulta de Retiros
                    </Typography>
                </Paper>

                {/* Filtros */}
                <Paper sx={{
                    p: 1.5,
                    mb: 1.5,
                    borderRadius: 2,
                    border: '1px solid rgba(30, 58, 95, 0.1)'
                }}>
                    <Grid container spacing={1.5}>
                        {/* Tipo de retiro */}
                        <Grid item xs={6}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="label-tipo-retiro-mobile">Tipo</InputLabel>
                                <Select
                                    labelId="label-tipo-retiro-mobile"
                                    id="tipo-retiro-mobile"
                                    label="Tipo"
                                    value={tipo}
                                    onChange={(event) => { setTipo(event.target.value) }}
                                    sx={{ fontSize: '0.85rem' }}
                                >
                                    <MenuItem value={0}>(Todos)</MenuItem>
                                    <MenuItem value={1}>Disponible</MenuItem>
                                    <MenuItem value={2}>Ganancias</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* Tipo retiro ganancia */}
                        <Grid item xs={6}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="label-tipo-retiro-ganancia-mobile">Destino</InputLabel>
                                <Select
                                    labelId="label-tipo-retiro-ganancia-mobile"
                                    id="tipo-retiro-ganancia-mobile"
                                    label="Destino"
                                    value={tipoRetiroGanancia}
                                    onChange={(event) => { setTipoRetiroGanancia(event.target.value) }}
                                    sx={{ fontSize: '0.85rem' }}
                                >
                                    <MenuItem value={0}>(Todos)</MenuItem>
                                    <MenuItem value={1}>Retiro</MenuItem>
                                    <MenuItem value={2}>A disponible</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* Fechas */}
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Desde"
                                value={desde}
                                onChange={(event) => { setDesde(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '0.85rem' }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Hasta"
                                value={hasta}
                                onChange={(event) => { setHasta(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '0.85rem' }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                {/* Resumen */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 1.5,
                    px: 1,
                    gap: 1
                }}>
                    <Chip
                        label={`${rows.length} retiros`}
                        size="small"
                        sx={{
                            backgroundColor: 'rgba(30, 58, 95, 0.1)',
                            color: '#1e3a5f',
                            fontWeight: 600,
                            fontSize: '0.7rem'
                        }}
                    />
                    <Chip
                        label={`Total: ${parseFloat(totalMovs).toLocaleString('en-US', { minimumFractionDigits: 2 })}`}
                        size="small"
                        sx={{
                            backgroundColor: 'rgba(212, 175, 55, 0.2)',
                            color: '#d4af37',
                            fontWeight: 600,
                            fontSize: '0.7rem'
                        }}
                    />
                </Box>

                {/* Lista de retiros */}
                <Box sx={{
                    flex: 1,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch'
                }}>
                    {renderMobileCards()}
                </Box>
            </Box>
        );
    }

    // Vista desktop
    return (
        <Box sx={{
            minHeight: "100vh",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            p: 3,
            pt: 4,
            backgroundColor: '#fafafb'
        }}>
            {objWait()}
            <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: 700, lg: 900, xl: 1050 } }}>
                {/* Header */}
                <Paper sx={{
                    p: 2,
                    mb: 2,
                    borderRadius: 2,
                    boxShadow: 3,
                    background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                    borderBottom: '3px solid #d4af37'
                }}>
                    <Typography variant="h6" sx={{ color: 'white', fontWeight: 700, textAlign: 'center', letterSpacing: 0.5 }}>
                        Consulta de Retiros
                    </Typography>
                </Paper>

                {/* Filtros */}
                <Paper sx={{
                    p: 2.5,
                    mb: 2,
                    borderRadius: 2,
                    boxShadow: 3,
                    border: '1px solid rgba(30, 58, 95, 0.1)'
                }}>
                    <Typography variant="body2" sx={{ color: '#1e3a5f', fontWeight: 600, mb: 1.5, display: 'block', textTransform: 'uppercase' }}>
                        Filtros de Reporte
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={6} md={3}>
                            <FormControl fullWidth size="medium">
                                <InputLabel id="label-tipo-retiro">Tipo</InputLabel>
                                <Select
                                    labelId="label-tipo-retiro"
                                    id="tipo-retiro"
                                    label="Tipo"
                                    value={tipo}
                                    onChange={(event) => { setTipo(event.target.value) }}
                                    sx={{ fontSize: '1rem' }}
                                >
                                    <MenuItem value={0}>(Todos)</MenuItem>
                                    <MenuItem value={1}>Disponible</MenuItem>
                                    <MenuItem value={2}>Ganancias</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormControl fullWidth size="medium">
                                <InputLabel id="label-tipo-retiro-ganancia">Destino</InputLabel>
                                <Select
                                    labelId="label-tipo-retiro-ganancia"
                                    id="tipo-retiro-ganancia"
                                    label="Destino"
                                    value={tipoRetiroGanancia}
                                    onChange={(event) => { setTipoRetiroGanancia(event.target.value) }}
                                    sx={{ fontSize: '1rem' }}
                                >
                                    <MenuItem value={0}>(Todos)</MenuItem>
                                    <MenuItem value={1}>Retiro</MenuItem>
                                    <MenuItem value={2}>A disponible</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <TextField
                                fullWidth
                                size="medium"
                                type="date"
                                label="Desde"
                                value={desde}
                                onChange={(event) => { setDesde(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '1rem' }
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <TextField
                                fullWidth
                                size="medium"
                                type="date"
                                label="Hasta"
                                value={hasta}
                                onChange={(event) => { setHasta(event.target.value) }}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                    '& .MuiInputBase-input': { fontSize: '1rem' }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                {/* Resumen y Exportar */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 1.5,
                    px: 1
                }}>
                    <Box sx={{ display: 'flex', gap: 1.5 }}>
                        <Chip
                            label={`${rows.length} retiros`}
                            size="medium"
                            sx={{
                                backgroundColor: 'rgba(30, 58, 95, 0.1)',
                                color: '#1e3a5f',
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                height: 32
                            }}
                        />
                        <Chip
                            label={`Total: ${parseFloat(totalMovs).toLocaleString('en-US', { minimumFractionDigits: 2 })}`}
                            size="medium"
                            sx={{
                                backgroundColor: 'rgba(212, 175, 55, 0.2)',
                                color: '#d4af37',
                                fontWeight: 600,
                                fontSize: '0.875rem',
                                height: 32
                            }}
                        />
                    </Box>
                    <ExportButtons
                        data={rows}
                        columns={[
                            { header: 'Fecha', field: 'fecha' },
                            { header: 'Concepto', field: 'nombre' },
                            { header: 'Monto', field: 'monto', type: 'money' }
                        ]}
                        filename="retiros"
                        title="Consulta de Retiros"
                    />
                </Box>

                {/* Tabla de resultados */}
                <Paper sx={{
                    borderRadius: 2,
                    boxShadow: 3,
                    overflow: 'hidden',
                    maxHeight: 550
                }}>
                    <Box sx={{ overflow: 'auto', maxHeight: 550 }}>
                        <Table stickyHeader size="medium">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{
                                        background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                        color: 'white',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        py: 1.25,
                                        borderBottom: '2px solid #d4af37'
                                    }}>Fecha</TableCell>
                                    <TableCell sx={{
                                        background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                        color: 'white',
                                        fontWeight: 600,
                                        fontSize: '0.9rem',
                                        py: 1.25,
                                        borderBottom: '2px solid #d4af37'
                                    }}>Concepto</TableCell>
                                    <TableCell sx={{
                                        background: 'linear-gradient(90deg, #1e3a5f 0%, #2c5282 100%)',
                                        color: 'white',
                                        fontWeight: 600,
                                        textAlign: 'right',
                                        fontSize: '0.9rem',
                                        py: 1.25,
                                        borderBottom: '2px solid #d4af37'
                                    }}>Monto</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows.map((row) => (
                                    <TableRow key={row.id} hover sx={{ '&:hover': { backgroundColor: 'rgba(44, 82, 130, 0.04)' } }}>
                                        <TableCell sx={{ color: '#1e3a5f', fontSize: '0.9rem', py: 1 }}>{row.fecha}</TableCell>
                                        <TableCell sx={{ color: '#1e3a5f', fontSize: '0.9rem', py: 1 }}>{row.nombre}</TableCell>
                                        <TableCell sx={{ textAlign: "right", color: '#d4af37', fontWeight: 500, fontSize: '0.9rem', py: 1 }}>
                                            {parseFloat(row.monto).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableFooter>
                                <TableRow sx={{ backgroundColor: '#f8fafc' }}>
                                    <TableCell colSpan={2} sx={{ fontWeight: 600, color: '#1e3a5f', fontSize: '0.9rem', py: 1.5 }}>
                                        {"Total: " + rows.length + " retiros"}
                                    </TableCell>
                                    <TableCell sx={{ textAlign: "right", fontWeight: 700, color: '#d4af37', fontSize: '1rem', py: 1.5 }}>
                                        {parseFloat(totalMovs).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    </Box>
                </Paper>
            </Box>
        </Box>
    )
}